import { create } from 'zustand';

const usePresenceStore = create((set, get) => ({
  // State
  // presenceMap: userId -> { status: 'online'|'away'|'dnd'|'offline', customText, emoji }
  presenceMap: {},
  // typingUsers: contextId -> Set of userIds
  typingUsers: {},

  // Actions
  updatePresence: (userId, presence) =>
    set((state) => ({
      presenceMap: {
        ...state.presenceMap,
        [userId]: { ...state.presenceMap[userId], ...presence },
      },
    })),

  bulkUpdatePresence: (presenceEntries) =>
    set((state) => {
      const updated = { ...state.presenceMap };
      presenceEntries.forEach(({ userId, ...presence }) => {
        updated[userId] = { ...updated[userId], ...presence };
      });
      return { presenceMap: updated };
    }),

  setTyping: (contextId, userId) =>
    set((state) => {
      const current = state.typingUsers[contextId]
        ? new Set(state.typingUsers[contextId])
        : new Set();
      current.add(userId);
      return {
        typingUsers: { ...state.typingUsers, [contextId]: current },
      };
    }),

  clearTyping: (contextId, userId) =>
    set((state) => {
      const current = state.typingUsers[contextId];
      if (!current) return state;
      const next = new Set(current);
      next.delete(userId);
      return {
        typingUsers: { ...state.typingUsers, [contextId]: next },
      };
    }),

  clearAllTyping: (contextId) =>
    set((state) => {
      const updated = { ...state.typingUsers };
      delete updated[contextId];
      return { typingUsers: updated };
    }),

  getPresence: (userId) =>
    get().presenceMap[userId] || { status: 'offline', customText: '', emoji: '' },

  getTypingUsers: (contextId) =>
    Array.from(get().typingUsers[contextId] || []),
}));

export default usePresenceStore;
